import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Tooltip } from 'dibs-elements/exports/Tooltip';
import { TooltipHeader } from 'dibs-elements/exports/TooltipHeader';
import CloseIcon from 'dibs-vg/dist/react/close';

import { saveToStorage } from './favoritesCalloutHelpers';

import styles from './Callout.scss';

export class Callout extends Component {
    state = {
        dismissed: false,
    };

    onCalloutClose(type) {
        this.setState({ dismissed: true }, saveToStorage({ type, turnOff: true }));
    }

    render() {
        const { copy, position, type, showOverlay } = this.props;
        const { dismissed } = this.state;
        const overlayClasses = classnames({
            [styles.overlay]: showOverlay,
            [styles.reveal]: !dismissed,
        });
        return (
            <React.Fragment>
                {showOverlay && <div className={overlayClasses} />}
                <Tooltip
                    isVisible={!dismissed}
                    direction={position}
                    type="coachmark"
                    onClose={() => this.onCalloutClose(type)}
                >
                    <TooltipHeader title={this.props.copy.header} />
                    <div>{copy.text}</div>
                    <span
                        className={styles.close}
                        onClick={() => this.onCalloutClose(type)}
                        data-tn="callout-close"
                    >
                        <CloseIcon className={styles.closeButton} />
                    </span>
                </Tooltip>
            </React.Fragment>
        );
    }
}

Callout.propTypes = {
    copy: PropTypes.object,
    type: PropTypes.string,
    position: PropTypes.oneOf(['top', 'left', 'bottom', 'right']),
    showOverlay: PropTypes.bool,
};
